// extracted by mini-css-extract-plugin
export default {"invoiceDetail":"InvoiceDetail_invoiceDetail__sJjld"};